var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D02038"
    },
    d: "M17.214,0v512h353.103v-1.766c-2.648-0.883-6.179-0.883-8.828-1.766l0,0  c-2.648-0.883-6.179-1.766-8.828-2.648l0,0c-2.648-0.883-5.297-1.766-7.945-3.531l0,0c-13.241-6.179-25.6-15.007-35.31-26.483  l-0.883-0.883c-1.766-1.766-2.648-3.531-3.531-5.297c-0.883-0.883-1.766-1.766-1.766-2.648c-0.883-1.766-1.766-3.531-2.648-4.414  c-0.883-0.883-1.766-2.648-2.648-3.531c-0.883-1.766-1.766-2.648-2.648-4.414c-0.883-1.766-1.766-2.648-1.766-4.414  c-0.883-1.766-0.883-2.648-1.766-4.414c-0.883-1.766-0.883-3.531-1.766-5.297c-0.883-1.766-0.883-2.648-1.766-4.414  c-0.883-1.766-0.883-3.531-1.766-5.297c0-1.766-0.883-2.648-0.883-4.414s-0.883-4.414-0.883-6.179c0-0.883,0-2.648-0.883-3.531  c0-3.531-0.883-7.062-0.883-10.593c0-3.531,0-7.062,0.883-10.593c0-0.883,0-2.648,0.883-3.531c0-2.648,0.883-4.414,0.883-6.179  c0-1.766,0.883-2.648,0.883-4.414c0-1.766,0.883-3.531,1.766-5.297c0-1.766,0.883-2.648,1.766-4.414  c0.883-1.766,0.883-3.531,1.766-5.297c0.883-1.766,0.883-2.648,1.766-4.414s1.766-2.648,1.766-4.414  c0.883-1.766,1.766-2.648,2.648-4.414c0.883-0.883,1.766-2.648,1.766-3.531c0.883-1.766,1.766-3.531,2.648-4.414  c0.883-0.883,1.766-1.766,1.766-2.648c0.883-1.766,2.648-3.531,3.531-5.297l0.883-0.883c9.71-11.476,22.069-20.303,35.31-26.483l0,0  c2.648-0.883,5.297-2.648,7.945-3.531l0,0c2.648-0.883,5.297-1.766,8.828-2.648l0,0c2.648-0.883,6.179-1.766,8.828-1.766V0H17.214z",
    "data-original": "#DB8D07",
    className: "",
    "data-old_color": "#d02038"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E5E3"
    },
    d: "M361.49,303.669C361.49,303.669,360.607,303.669,361.49,303.669  c-3.531,0.883-6.179,1.766-8.828,2.648l0,0c-2.648,0.883-5.297,1.766-7.945,3.531l0,0c-13.241,6.179-25.6,15.007-35.31,26.483  l-0.883,0.883c-1.766,1.766-2.648,3.531-3.531,5.297c-0.883,0.883-1.766,1.766-1.766,2.648c-0.883,1.766-1.766,3.531-2.648,4.414  c-0.883,0.883-1.766,2.648-1.766,3.531c-0.883,1.766-1.766,2.648-2.648,4.414c-0.883,1.766-1.766,2.648-1.766,4.414  c-0.883,1.766-0.883,2.648-1.766,4.414c-0.883,1.766-0.883,3.531-1.766,5.297c-0.883,1.766-0.883,2.648-1.766,4.414  c-0.883,1.766-0.883,3.531-1.766,5.297c0,1.766-0.883,2.648-0.883,4.414c0,1.766-0.883,4.414-0.883,6.179  c0,0.883,0,2.648-0.883,3.531c0,3.531-0.883,7.062-0.883,10.593c0,3.531,0,7.062,0.883,10.593c0,0.883,0,2.648,0.883,3.531  c0,2.648,0.883,4.414,0.883,6.179s0.883,2.648,0.883,4.414c0,1.766,0.883,3.531,1.766,5.297c0,1.766,0.883,2.648,1.766,4.414  c0.883,1.766,0.883,3.531,1.766,5.297c0.883,1.766,0.883,2.648,1.766,4.414c0.883,1.766,1.766,2.648,1.766,4.414  c0.883,1.766,1.766,2.648,2.648,4.414c0.883,0.883,1.766,2.648,2.648,3.531c0.883,1.766,1.766,3.531,2.648,4.414  c0.883,0.883,1.766,1.766,1.766,2.648c0.883,1.766,2.648,3.531,3.531,5.297l0.883,0.883c9.71,11.476,22.069,20.303,35.31,26.483l0,0  c2.648,0.883,5.297,2.648,7.945,3.531l0,0c2.648,0.883,5.297,1.766,8.828,2.648l0,0c2.648,0.883,6.179,1.766,8.828,1.766l0,0  c6.179,0.883,11.476,1.766,17.655,1.766c58.262,0,105.931-47.669,105.931-105.931s-47.669-105.931-105.931-105.931  c-6.179,0-11.476,0.883-17.655,1.766l0,0C367.669,301.903,364.138,302.786,361.49,303.669z",
    "data-original": "#841F19",
    className: "",
    "data-old_color": "#e6e5e3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M341.186,376.938l22.952,22.952c3.531,3.531,3.531,8.828,0,12.359L341.186,435.2  c-3.531,3.531-3.531,8.828,0,12.359l5.297,5.297c3.531,3.531,8.828,3.531,12.359,0l22.952-22.952c3.531-3.531,8.828-3.531,12.359,0  l22.952,22.952c3.531,3.531,8.828,3.531,12.359,0l5.297-5.297c3.531-3.531,3.531-8.828,0-12.359l-22.952-22.952  c-3.531-3.531-3.531-8.828,0-12.359l22.952-22.952c3.531-3.531,3.531-8.828,0-12.359l-5.297-5.297  c-3.531-3.531-8.828-3.531-12.359,0l-22.952,22.952c-3.531,3.531-8.828,3.531-12.359,0l-22.952-22.952  c-3.531-3.531-8.828-3.531-12.359,0l-5.297,5.297C337.655,368.11,337.655,373.407,341.186,376.938z",
    "data-original": "#DDDDDB",
    className: "",
    "data-old_color": "#FCFCF3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M273.214,52.966H114.317c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h158.897c5.297,0,8.828,3.531,8.828,8.828l0,0C282.041,49.434,278.51,52.966,273.214,52.966z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M149.628,158.897H79.007c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h70.621c5.297,0,8.828,3.531,8.828,8.828l0,0C158.455,155.366,154.924,158.897,149.628,158.897z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M264.386,158.897h-79.448c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h79.448c5.297,0,8.828,3.531,8.828,8.828l0,0C273.214,155.366,269.683,158.897,264.386,158.897z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M237.903,203.034h-70.621c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h70.621c5.297,0,8.828,3.531,8.828,8.828l0,0C246.731,199.503,243.2,203.034,237.903,203.034z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M308.524,247.172H167.283c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h141.241c5.297,0,8.828,3.531,8.828,8.828l0,0C317.352,243.641,313.821,247.172,308.524,247.172z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M308.524,291.31H79.007c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h229.517c5.297,0,8.828,3.531,8.828,8.828l0,0C317.352,287.779,313.821,291.31,308.524,291.31z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M308.524,158.897h-8.828c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h8.828c5.297,0,8.828,3.531,8.828,8.828l0,0C317.352,155.366,313.821,158.897,308.524,158.897z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M308.524,203.034h-35.31c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h35.31c5.297,0,8.828,3.531,8.828,8.828l0,0C317.352,199.503,313.821,203.034,308.524,203.034z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M246.731,335.448H79.007c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h167.724c5.297,0,8.828,3.531,8.828,8.828l0,0C255.559,331.917,252.028,335.448,246.731,335.448z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M246.731,379.586H79.007c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h167.724c5.297,0,8.828,3.531,8.828,8.828l0,0C255.559,376.055,252.028,379.586,246.731,379.586z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M114.317,423.724h-35.31c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h35.31c5.297,0,8.828,3.531,8.828,8.828l0,0C123.145,420.193,119.614,423.724,114.317,423.724z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M246.731,423.724h-97.103c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h97.103c5.297,0,8.828,3.531,8.828,8.828l0,0C255.559,420.193,252.028,423.724,246.731,423.724z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M308.524,114.759H79.007c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h229.517c5.297,0,8.828,3.531,8.828,8.828l0,0C317.352,111.228,313.821,114.759,308.524,114.759z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M123.145,203.034H79.007c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h44.138c5.297,0,8.828,3.531,8.828,8.828l0,0C131.972,199.503,128.441,203.034,123.145,203.034z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDF6"
    },
    d: "M131.972,247.172H79.007c-5.297,0-8.828-3.531-8.828-8.828l0,0c0-5.297,3.531-8.828,8.828-8.828   h52.966c5.297,0,8.828,3.531,8.828,8.828l0,0C140.8,243.641,137.269,247.172,131.972,247.172z",
    "data-original": "#7E3B04",
    className: "active-path",
    "data-old_color": "#F9F9F2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.e8de6e3f72bd572211f03afd0888a361.svg";
export { ForwardRef as ReactComponent };